if (!customElements.get("details-disclosure")) {
  customElements.define(
    "details-disclosure",
    class DetailsDisclosure extends HTMLElement {
      constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");
        this.summary = this.mainDetailsToggle.querySelector("summary");
        this.content = this.summary.nextElementSibling;
        //this.setContentHeight();
        this.bindEvents();
      }

      bindEvents() {
        this.summary.addEventListener("click", this.onToggle.bind(this));
        this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
      }

      onFocusOut(event) {
        setTimeout(() => {
          if (!this.contains(document.activeElement) && this.mainDetailsToggle.dataset.escape && this.mainDetailsToggle.hasAttribute("open")) this.close();
        });
      }

      getTotalChildrenHeight(parent) {
        let totalHeight = 0;
        const children = parent.children;

        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          const childHeight = child.offsetHeight;
          totalHeight += childHeight;
        }

        return totalHeight;
      }

      setContentHeight() {
        this.content.style.setProperty(
          "--content-height",
          `${this.getTotalChildrenHeight(this.content)}px`
        );
      }

      onToggle(event) {
        event.preventDefault();

        // Get the element to toggle
        const detailsToggle = this.mainDetailsToggle;
        const detailsContent = this.content;
        const isOpen = detailsToggle.hasAttribute("open");

        // Add event listener for transition end
        const onTransitionEnd = () => {
          if (isOpen) {
            detailsToggle.removeAttribute("open");
          } else {
            detailsToggle.classList.add("active");
            detailsToggle.classList.remove("animating");
          }

          detailsContent.removeEventListener("transitionend", onTransitionEnd);
        };

        // Toggle the state
        if (!isOpen) {
          // Close siblings if this element has data-close-siblings attribute
          if (this.hasAttribute('data-close-siblings')) {
            this.closeSiblings();
          }

          detailsToggle.setAttribute("open", true);
          this.setContentHeight();
          detailsToggle.classList.add("animating");
          detailsContent.addEventListener("transitionend", onTransitionEnd);
        } else {
          this.setContentHeight();
          detailsToggle.classList.add("animating");
          requestAnimationFrame(() => {
            detailsToggle.classList.remove("active");
            requestAnimationFrame(() => {
              detailsToggle.classList.remove("animating");
              detailsContent.addEventListener("transitionend", onTransitionEnd);
            });
          });          
        }
      }

      close() {
        const detailsToggle = this.mainDetailsToggle;
        const detailsContent = this.content;

        // Add event listener for transition end
        const onTransitionEnd = () => {
          detailsToggle.removeAttribute("open");
          detailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
          detailsContent.removeEventListener("transitionend", onTransitionEnd);
        };

        this.setContentHeight();
        detailsToggle.classList.add("animating");
        requestAnimationFrame(() => {
          detailsToggle.classList.remove("active");
          requestAnimationFrame(() => {
            detailsToggle.classList.remove("animating");
            detailsContent.addEventListener("transitionend", onTransitionEnd);
          });
        });      
      }

      closeSiblings() {
        // Find the parent element
        const parent = this.parentElement?.parentElement;
        if (!parent) return;

        // Find all sibling details-disclosure elements with the same attribute
        const siblings = parent.querySelectorAll('details-disclosure[data-close-siblings]');
        
        siblings.forEach(sibling => {
          // Skip the current element
          if (sibling === this) return;
          
          // Close the sibling if it's open
          const siblingDetails = sibling.querySelector('details');
          if (siblingDetails && siblingDetails.hasAttribute('open')) {
            sibling.close();
          }
        });
      }
    }
  );
}
